<!-- <main class="layout">
  <app-nav-header></app-nav-header>
  <div class="content-area">
    <router-outlet></router-outlet>
    <app-error-dialog [errorContents]="errorContent" [hidden]="!isShowError"></app-error-dialog>
  </div>
  <app-nav-footer></app-nav-footer>
</main> -->
<router-outlet></router-outlet>